<template>
	<v-app theme="dark" style="background-color: #ffffff">
		<v-toolbar elevation="0" dense absolute class="mt-10 ml-10 mb-10">
			<v-img
				alt="Orixe Logo"
				:src="require('../../assets/Logo_Header_White.svg')"
				width="225"
			/>
		</v-toolbar>
		<v-main>
			<v-container fluid class="fill-height" pa-0>
				<v-layout row wrap>
					<!-- Left panel -->
					<v-flex xs12 sm12 md6 class="bluebg">
						<v-container fill-height fluid>
							<v-row align="center" justify="center">
								<v-col class="mb-4 mt-16">
									<div class="text-center">
										<h1 class="white--text mx-1">Incident Reporting</h1>
										<p class="mx-1 larger-text">
											<b>Report and resolve incidents quickly and securely.</b>
										</p>
									</div>
								</v-col>
							</v-row>
						</v-container>
					</v-flex>

					<!-- Right panel: login form -->
					<v-flex xs12 sm12 md6 class="white">
						<v-container fill-height fluid>
							<v-row align="center" justify="center">
								<v-col cols="8">
									<div class="text-center mx-5">
										<h1 class="text-left primary--text mb-4">
											<span class="larger-text">Log In</span>
										</h1>

										<v-form @submit.prevent="login">
											<v-alert v-if="error" type="error" class="mb-6">
												{{ error }}
											</v-alert>

											<v-text-field
												label="E-mail"
												v-model="email"
												name="login"
												placeholder="email@example.com"
												outlined
												type="text"
												light
												color="primary"
											></v-text-field>

											<v-text-field
												id="password"
												label="Password"
												name="password"
												placeholder="Password"
												outlined
												:type="passwordVisible ? 'text' : 'password'"
												v-model="password"
												:append-icon="
													passwordVisible ? 'fas fa-eye' : 'fas fa-eye-slash'
												"
												@click:append="passwordVisible = !passwordVisible"
												light
											></v-text-field>

											<!-- Manager checkbox -->
											<div class="manager-box mb-4">
												<v-checkbox
													v-model="isManager"
													label="I'm a Manager"
													color="primary"
													hide-details
													light
													class="mt-0 pt-0"
												></v-checkbox>
											</div>

											<!-- Shown only when the manager box is ticked -->
											<v-text-field
												v-if="isManager"
												label="Username"
												v-model="username"
												name="username"
												placeholder="Username"
												outlined
												type="text"
												light
												color="primary"
												style="clear: both"
											></v-text-field>

											<div class="text-center mt-4" style="clear: both">
												<v-btn
													x-large
													type="submit"
													color="orangeButton"
													dark
													:loading="loading"
												>
													Login
												</v-btn>
											</div>
										</v-form>
									</div>
								</v-col>
							</v-row>
						</v-container>
					</v-flex>
				</v-layout>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import { riskAPI } from "../../api/csr/risk"

export default {
	name: "Login",

	data() {
		return {
			email: null,
			password: null,
			isManager: false,
			username: null,
			passwordVisible: false,
			loading: false,
			error: null
		}
	},

	watch: {
		// Clear the username when the manager box is unticked
		isManager(val) {
			if (!val) this.username = null
		}
	},

	methods: {
		async login() {
			this.error = null

			if (!this.email || !this.password) {
				this.error = "Please enter your email and password."
				return
			}

			if (this.isManager && !this.username) {
				this.error = "Please enter your manager username."
				return
			}

			this.loading = true
			try {
				const result = await riskAPI.loginIncident({
					email: this.email,
					password: this.password,
					managerUsername: this.isManager ? this.username : undefined
				})

				// Keep the role and the client ID for the other pages
				localStorage.setItem("incidentRole", result.role)
				localStorage.setItem("incidentClientID", result.clientID)

				this.$router.push(
					result.role === "manager"
						? "/incidentreport/overview"
						: "/incidentreport/form"
				)
			} catch (err) {
				this.error = err.message || "Login failed. Please try again."
			} finally {
				this.loading = false
			}
		}
	}
}
</script>

<style scoped>
.larger-text {
	font-size: 1.4em;
}

::v-deep .v-text-field input {
	font-size: 1.2em;
	height: 100%;
}

::v-deep .v-text-field label {
	font-size: 1.5em;
}

::v-deep .v-toolbar {
	background-color: transparent !important;
}

.bluebg {
	background: transparent linear-gradient(130deg, #21b8c3 0%, #109ca7 100%) 0%
		0% no-repeat padding-box;
	color: white;
}

.manager-box {
	display: inline-block;
	width: 60%;
	min-width: 220px;
	float: left;
	text-align: left;
	padding: 18px 16px;
	background: #f9f9f9;
	border: 1px solid #e0e0e0;
	border-radius: 2px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
</style>